<section class="parker-banner">
    <app-mini-env-banner   bgColor="var(--white)" [slides]="bannerSlides" (butonAction)="onSliderBtnAction($event)"></app-mini-env-banner>
    <div class="brought d-flex justify-content-center">
      <div>
        <div class="d-flex align-items-center parker-img-row">
          <div class="d-flex align-items-center" style="gap: 10px;">
            <span class="brought-to">Brought to you in Collaboration with</span>
          </div>
          <div>
            <div class="d-flex">
              <div>
                <img class="logo-white" [src]="sharedService.imagesUrl + 'wow-health-logo-white.svg'" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>  

<section class="container-fluid services-section">
    <div class="container">
        
        <app-mini-env-heading-block
            [miniTitle]="'Easy Medicine Access'"
            [title]="'Ease of Access to Healthcare'"
            [description]="'Your healthcare gets super easy and accessible when it is at your fingertips, no long waits or queue hassles.'"
            [style]="'max-width: 684px;'"
            ></app-mini-env-heading-block>

        <div class="responsive-tabs mt-20">

                <div class="tab-body">
                    <app-mini-env-content-box [imgSrc]="imgSrc">
                      <h2 class="content-heading">{{ serviceDetails?.heading }}</h2>
                      <p class="content-txt">
                          {{ serviceDetails?.subHeading }}
                      </p>

                          <ul class="d-flex content-list">
                              <li class="bullet" *ngFor="let item of serviceDetails?.pointsList">
                                  <div>
                                      <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
                                  </div>
                                  <div>
                                      <span class="bullet-heading">{{ item?.title }}: </span>
                                      <span>{{ item?.description }}</span>
                                  </div>
                              </li>
                          </ul>
                   </app-mini-env-content-box>
                </div>

        </div>
    </div>
</section>

<!-- <section class="video-section">
  <div class="container-fluid">

     <app-mini-env-heading-block
    [miniTitle]="'See WoW Health in Action'"
    [title]="'A Sneak Peek Inside WoW Health'"
    [description]="'Step inside WoW Health and see what makes us different. Thoughtfully designed to support your health journey every step of the way.'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

    <div class="container">
      <app-video-player></app-video-player>
    </div>
  </div>
</section> -->

<section class="container-fluid bg-white avail-benefits">

  <app-mini-env-heading-block
    [miniTitle]="'How it Works'"
    [title]="'Your Care, Step by Step'"
    [description]="'We’ve streamlined the process so you don’t have to think twice. From start to finish, everything is designed to be quick and easy.'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll [steps]="steps" [imgLink]="imgLink"></app-imagebox-bullet-scroll>
</section>

<!-- <section class="container-fluid">
    <div class="container">
        <div class="tabs">

            <div class="tab-headers">
                <button
                *ngFor="let pane of panes; let i = index"
                (click)="select(i)"
                [class.active]="pane.active"
                class="tab-btn"
                >
                {{ pane.title }}
                </button>
            </div>

            <div class="tab-body">
                <div *ngFor="let pane of panes; let i = index">
                    <app-mini-env-content-box *ngIf="pane.active" [imgSrc]="imgSrc">
                        <h2 class="content-heading">{{ pane.title }}</h2>
                        <p class="content-txt">
                        Licensed Medics to guide with care decisions, with FREE virtual care.
                        </p>

                        <ul class="d-flex content-list">
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Virtual Primary Care:</span> Appointment with the same doctor - no long waiting hours.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Virtual Urgent Care:</span> 24/7 access to virtual care for non-emergency issues.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Tele counseling:</span> 24/7 Mental health and personal life support with specialists.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Message-a-specialist:</span> Quick response on medical concerns via secure chat.</li>
                        </ul>

                        <button class="btn btn-primary">Get Started</button>
                    </app-mini-env-content-box>
                </div>
            </div>

        </div>
    </div>
</section> -->

<section class="container-fluid login-section">
  <app-mini-env-heading-block  [title]="'Start Your Health Transformation Today'"
    [description]="'Don’t wait another moment to take control of your health. Access personalized, convenient, and affordable healthcare solutions right at your fingertips.'"
    [style]="'max-width: 749px;'"></app-mini-env-heading-block>
    <button (click)="login()" class="login-btn-redirect">Get Started Now</button>
</section>

<section class="container-fluid faq-section">
  <div class="container">
    
    <app-mini-env-heading-block
    [miniTitle]="'FAQs'"
    [title]="'Frequently Asked Questions'"
    [description]="'Need help? Our dedicated customer support team is available 24/7 to answer your questions and provide assistance. Call us anytime at 844-969-4325.'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

    <div class="mt-30">
       <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>  

<!--  How can we help Section End-->
